var _circle, _rect, _line, _rect2, _line2, _rect3, _line3, _rect4, _line4, _rect5, _line5, _rect6, _line6, _rect7, _line7, _rect8, _line8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanquet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 6,
    fill: "#6E6B7B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 3,
    height: 3,
    rx: 1,
    fill: "#6E6B7B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 1.2998,
    x2: 13.5,
    y2: 1.2998,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "matrix(1 0 0 -1 11 21.7998)",
    fill: "#6E6B7B"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: -0.5,
    transform: "matrix(1 0 0 -1 11 22)",
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4396,
    y: 3.83911,
    width: 3,
    height: 3,
    rx: 1,
    transform: "rotate(45 18.4396 3.83911)",
    fill: "#6E6B7B"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19.2883,
    y1: 3.69751,
    x2: 20.7025,
    y2: 5.11172,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 4.43903 17.8396)",
    fill: "#6E6B7B"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: -0.5,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 4.29749 17.9812)",
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3999,
    y: 10.5,
    width: 3,
    height: 3,
    rx: 1,
    transform: "rotate(90 22.3999 10.5)",
    fill: "#6E6B7B"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 23.1001,
    y1: 11,
    x2: 23.1001,
    y2: 13,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 2.6001 10.5)",
    fill: "#6E6B7B"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: -0.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 2.3999 10.5)",
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.561,
    y: 17.9397,
    width: 3,
    height: 3,
    rx: 1,
    transform: "rotate(135 20.561 17.9397)",
    fill: "#6E6B7B"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 20.7025,
    y1: 18.7884,
    x2: 19.2883,
    y2: 20.2026,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 6.56036 3.93921)",
    fill: "#6E6B7B"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 6.41882 3.79761)",
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanquet);
export default __webpack_public_path__ + "static/media/banquet.77a0a7b9dd60a023b8a3a9352a5276c5.svg";
export { ForwardRef as ReactComponent };